export default "__VITE_ASSET__qTRB3ag2__"